import { IForm } from "../interfaces/form";

export const FORM_EDIT = ({
  defaultValue = "",
  deliveryOptions = [],
}: IForm) => {
  return [
    {
      ref: "maintainId",
      name: "maintainId",
      label: "รหัสหมายเลขการซ่อม",
      type: "INPUT",
      span: 12,
      disabled: true,
      defaultValue,
    },
    {
      ref: "deviceId",
      name: "deviceId",
      label: "รหัสหมายเลขเครื่อง",
      type: "INPUT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกรหัสหมายเลขเครื่องให้ถูกต้อง",
        },
      },
    },
    {
      ref: "versionMachine",
      name: "versionMachine",
      label: "version เครื่องตัด",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "customerCode",
      name: "customerCode",
      label: "รหัสลูกค้า",
      type: "INPUT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกรหัสลูกค้าให้ถูกต้อง",
        },
      },
    },
    {
      ref: "deviceSpareId",
      name: "deviceSpareId",
      label: "รหัสหมายเลขเครื่อง Spare",
      type: "INPUT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกรหัสหมายเลขเครื่องให้ถูกต้อง",
        },
      },
    },
    {
      ref: "delivery",
      name: "delivery",
      id: "delivery",
      label: "ประเภทขนส่ง",
      type: "SELECT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกประเภทขนส่ง",
        },
      },
      properties: {
        options: deliveryOptions || [],
        valueKey: "deliveryId",
        labelKey: "deliveryName",
      },
    },
    {
      ref: "trackingNo",
      name: "trackingNo",
      id: "trackingNo",
      label: "Tracking No.",
      type: "INPUT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอก Tracking No.",
        },
      },
    },
    {
      ref: "reasonSpare",
      name: "reasonSpare",
      label: "เหตุผลขอสแปร์",
      type: "INPUT",
      span: 24,
      disabled: true,
    },
  ];
};

export const FORM_SEARCH = ({
  optionsChangeDevice = [],
  onSubmitSearch,
}: any) => {
  return [
    {
      ref: "search_maintainId",
      name: "search_maintainId",
      label: "หมายเลขการซ่อม",
      type: "INPUT",
      placeholder: "ตัวอย่าง DMTH2205-0094",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_customerCode",
      name: "search_customerCode",
      label: "รหัสลูกค้า / ชื่อลูกค้า",
      type: "INPUT",
      placeholder: "ตัวอย่าง TUP-NMI-22-0045",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_saleCode",
      name: "search_saleCode",
      label: "รหัสเซลล์",
      type: "INPUT",
      placeholder: "รหัสเซล์",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_maintainSpareStatus",
      name: "search_maintainSpareStatus",
      label: "สถานะ",
      placeholder: "สถานะ",
      type: "SELECT",
      span: 6,
      properties: {
        options: optionsChangeDevice,
        valueKey: "value",
        labelKey: "label",
      },
    },
  ];
};
